{
  "common": {
    "memberCenter": "Member Center",
    "points": "Points",
    "level": "Level",
    "coupons": "Coupons",
    "checkin": "Check In",
    "history": "History",
    "balance": "Balance",
    "expire": "Expire",
    "confirm": "Confirm",
    "cancel": "Cancel",
    "loading": "Loading...",
    "noData": "No data",
    "retry": "Retry",
    "success": "Success",
    "failed": "Failed"
  },
  "points": {
    "earn": "Earn {amount} points",
    "spend": "Spend {amount} points",
    "balance": "Current balance: {amount} points",
    "expired": "{amount} points expired",
    "estimated": "Estimated (pending confirmation)"
  },
  "level": {
    "current": "Current level: {name}",
    "nextLevel": "Next level: {name}",
    "progress": "{current}/{target} to next level",
    "upgraded": "Congratulations! Upgraded to {name}"
  },
  "coupon": {
    "claim": "Claim",
    "claimed": "Claimed",
    "expired": "Expired",
    "used": "Used",
    "validUntil": "Valid until {date}",
    "threshold": {
      "none": "No minimum",
      "min": "Min. order {amount}"
    }
  },
  "checkin": {
    "today": "Check in today",
    "done": "Checked in",
    "streak": "{days} day streak",
    "reward": "+{amount} points"
  },
  "errors": {
    "network": "Network error, please try again",
    "unauthorized": "Please login first",
    "serverError": "Server error, please try later",
    "timeout": "Request timeout"
  },
  "ui": {
    "memberCenter": {
      "loading": "Loading...",
      "avatarAlt": "Member avatar",
      "pointsBalance": "My Points",
      "menuLabel": "Member navigation",
      "menu": {
        "pointsDetail": "Points History",
        "levelDetail": "Level Benefits",
        "coupons": "My Coupons",
        "referral": "Invite Friends",
        "checkin": "Daily Check-in",
        "orders": "My Orders"
      }
    },
    "pointsDetail": {
      "title": "Points History",
      "empty": "No points transactions yet",
      "loading": "Loading...",
      "noMore": "No more records",
      "listLabel": "Points transactions",
      "status": {
        "pending": "Pending",
        "active": "Active",
        "used": "Used",
        "expired": "Expired"
      }
    },
    "levelProgress": {
      "loading": "Loading...",
      "maxLevel": "Max level reached",
      "progressLabel": "Level progress",
      "noBenefits": "No benefits yet",
      "nextLevel": "Next level: {name}",
      "benefitsTitle": "My Benefits"
    },
    "couponList": {
      "title": "My Coupons",
      "tabsLabel": "Coupon categories",
      "listLabel": "Coupon list",
      "empty": "No coupons available",
      "freeShipping": "Free Shipping",
      "giftValue": "Gift",
      "discountValue": "{value}% OFF",
      "type": {
        "discount": "Discount",
        "cash": "Cash",
        "shipping": "Shipping",
        "gift": "Gift"
      },
      "tab": {
        "claimable": "Claim",
        "unused": "Unused",
        "used": "Used",
        "expired": "Expired"
      },
      "loadingClaimable": "Loading...",
      "noClaimable": "No coupons to claim",
      "claiming": "Claiming...",
      "claim": "Claim",
      "stockInfo": "{remaining} left",
      "stockUnlimited": "Unlimited",
      "minOrder": "Min. order {amount}"
    },
    "referralShare": {
      "loading": "Loading...",
      "title": "Invite Friends",
      "shareTitle": "Invite friends to earn points",
      "shareText": "Join now and get a reward on signup!",
      "invitedCount": "Invited",
      "rewardPoints": "Points Earned",
      "codeLabel": "My Referral Code",
      "linkLabel": "Referral Link",
      "copy": "Copy",
      "copyCode": "Copy referral code",
      "share": "Share",
      "rewardHint": "Earn {points} points per friend invited",
      "tabShare": "Invite",
      "tabRecords": "Records",
      "loadingRecords": "Loading records...",
      "noRecords": "No invitations yet",
      "anonymousUser": "Anonymous",
      "prevPage": "Previous",
      "nextPage": "Next",
      "recordsLabel": "Invitation records",
      "status": {
        "registered": "Registered",
        "first_order": "First Order",
        "rewarded": "Rewarded"
      }
    },
    "checkinCalendar": {
      "loading": "Loading...",
      "checking": "Checking in...",
      "checkin": "Check In",
      "alreadyChecked": "Checked in",
      "day": "{count} days",
      "title": "Daily Check-in",
      "streak": "{days} day streak",
      "calendarLabel": "Check-in calendar",
      "rewardsTitle": "Streak Rewards",
      "rewardsLabel": "Streak rewards list",
      "prevMonth": "Previous month",
      "nextMonth": "Next month",
      "monthDays": "{count} days checked",
      "monthPoints": "Points earned",
      "weekday": {
        "sun": "Sun",
        "mon": "Mon",
        "tue": "Tue",
        "wed": "Wed",
        "thu": "Thu",
        "fri": "Fri",
        "sat": "Sat"
      }
    },
    "orderList": {
      "loading": "Loading orders...",
      "title": "Order History",
      "noOrders": "No order records yet",
      "listLabel": "Order records list",
      "prevPage": "Previous",
      "nextPage": "Next",
      "typePoints": "Points",
      "typeGrowth": "Growth",
      "bizType": {
        "Order_Pay": "Order Payment",
        "Order_Refund": "Order Refund"
      },
      "status": {
        "pending": "Pending",
        "active": "Active",
        "invalid": "Invalid",
        "used": "Used",
        "expired": "Expired"
      }
    },
    "addressManager": {
      "title": "My Addresses",
      "add": "Add Address",
      "empty": "No addresses yet",
      "default": "Default",
      "setDefault": "Set Default",
      "edit": "Edit",
      "delete": "Delete"
    },
    "accountSettings": {
      "title": "Account Settings",
      "dataExport": {
        "title": "Export My Data",
        "desc": "Download a copy of all your personal data",
        "button": "Request Export",
        "processing": "Processing..."
      },
      "deleteAccount": {
        "title": "Delete Account",
        "desc": "Permanently delete your account and all associated data",
        "button": "Delete Account",
        "confirm": "This action cannot be undone. All your data will be permanently deleted.",
        "confirmButton": "Yes, Delete My Account",
        "cancel": "Cancel"
      }
    },
    "checkout": {
      "points": {
        "title": "Points Deduction",
        "unit": "pts",
        "available": "Available",
        "deduct": "Deduct"
      },
      "coupon": {
        "title": "Coupon",
        "none": "No coupon"
      },
      "summary": {
        "order": "Order Total",
        "discount": "Discount",
        "total": "Pay"
      }
    },
    "profile": {
      "form": {
        "nickname": "Nickname",
        "avatar": "Avatar URL",
        "locale": "Language",
        "save": "Save",
        "saving": "Saving..."
      }
    },
    "auth": {
      "login": {
        "emailLabel": "Email",
        "passwordLabel": "Password",
        "submit": "Log In",
        "createAccount": "Create Account",
        "forgotPassword": "Forgot Password?",
        "orDivider": "or"
      },
      "register": {
        "emailLabel": "Email",
        "passwordLabel": "Password",
        "confirmPasswordLabel": "Confirm Password",
        "passwordHint": "At least 8 characters, with letters and numbers",
        "submit": "Create Account",
        "submitting": "Creating...",
        "hasAccount": "Already have an account? Log In",
        "passwordMismatch": "Passwords do not match"
      },
      "oauth": {
        "continueWith": "Continue with {provider}"
      },
      "verify": {
        "title": "Verify Your Email",
        "description": "We've sent a verification code to {email}",
        "digitLabel": "Digit {index}",
        "resend": "Resend Code",
        "resendCountdown": "Resend ({countdown}s)",
        "backToRegister": "Back to Register"
      },
      "forgot": {
        "title": "Reset Password",
        "description": "Enter your email and we'll send you a verification code.",
        "emailLabel": "Email",
        "submit": "Send Code",
        "backToLogin": "Back to Login"
      }
    },
    "error": {
      "network": "Network error, please try again",
      "retry": "Retry",
      "retryLabel": "Retry loading"
    }
  },
  "sdk": {
    "error": {
      "210900": "Invalid parameters",
      "210901": "Tenant ID is required",
      "210902": "Too many requests, please try later",
      "210903": "Unauthorized",
      "210904": "Token expired",
      "210905": "Invalid token",
      "210906": "Token refresh failed",
      "210907": "Platform token exchange failed",
      "210908": "Invalid refresh token",
      "210909": "Refresh token expired",
      "210911": "Member not found",
      "210912": "Level info not found",
      "210920": "This email is already registered",
      "210921": "Password too weak: at least 8 characters with letters and numbers",
      "210922": "Verification code sent too frequently, please try later",
      "210923": "Invalid or expired verification code",
      "210924": "Registration info expired, please register again",
      "210925": "Incorrect email or password",
      "210926": "Email not verified, please verify first",
      "210927": "OAuth authentication failed",
      "210928": "OAuth state invalid or expired",
      "210929": "Unsupported login method",
      "210930": "User creation failed",
      "210931": "Discount calculation failed",
      "210951": "Points balance query failed",
      "210952": "Points transactions query failed",
      "210953": "Points earning failed",
      "210954": "Points activation failed",
      "210955": "Points spending failed",
      "210956": "Insufficient points balance",
      "210957": "Points ledger not found",
      "210958": "Points status does not allow this operation",
      "210971": "Coupon out of stock",
      "210972": "Coupon already claimed",
      "210981": "Message queue write failed",
      "210982": "Internal service sync failed",
      "210983": "Exchange product not found",
      "210984": "Redemption failed",
      "210985": "Referral code not found",
      "210986": "Referral binding failed",
      "210987": "Referrer not found",
      "210988": "Cannot invite yourself",
      "210989": "Coupon claim failed",
      "210990": "Already checked in today",
      "210991": "Check-in failed",
      "211001": "Webhook signature verification failed",
      "211002": "Unsupported webhook platform",
      "211003": "Duplicate webhook request",
      "211004": "Webhook secret not configured",
      "211005": "Webhook timestamp expired",
      "211900": "Operation failed, please try again",
      "211901": "Authentication failed",
      "211902": "Account not bound",
      "211903": "Access denied",
      "211904": "Configuration not found",
      "211905": "Invalid configuration scope",
      "211906": "Role not found",
      "211907": "System role cannot be deleted",
      "211908": "No access to this tenant",
      "211909": "Validation failed",
      "211910": "Resource not found",
      "211911": "Member not found",
      "211912": "Identity conflict, please contact support",
      "211913": "Shadow account activation failed",
      "211914": "Review record not found",
      "211915": "Review record status is not pending",
      "211916": "OneID not found",
      "211917": "OneID unlink failed",
      "211931": "Level configuration not found",
      "211932": "Level has associated members, cannot delete",
      "211933": "Level upgrade condition validation failed",
      "211934": "Level sequence must be continuous",
      "211951": "Ledger status transition invalid",
      "211952": "Insufficient points balance",
      "211953": "Ledger record not found",
      "211954": "Duplicate points transaction",
      "211955": "Invalid points amount",
      "211956": "Points deduction exceeds max ratio",
      "211957": "Points below minimum threshold",
      "211958": "Points earning rule not configured",
      "211959": "Points activation failed: status is not pending",
      "211960": "Points transaction access denied",
      "211961": "Points already expired",
      "211962": "Growth rule not configured",
      "211971": "Coupon template not found",
      "211972": "Coupon template status invalid",
      "211973": "Coupon per-user limit exceeded",
      "211974": "Coupon total quota exceeded",
      "211975": "Coupon redemption status invalid",
      "211976": "Coupon expired",
      "211977": "Coupon template has issued coupons, cannot delete",
      "211981": "Push task not found",
      "211982": "Push task status does not allow editing",
      "211983": "Push task status does not allow cancellation",
      "211984": "Push template not found",
      "211985": "Push target audience is empty",
      "211991": "Service busy, please try again later",
      "211992": "Message publish failed",
      "211993": "Message entered dead letter queue",
      "network": "Network error, please check your connection",
      "timeout": "Request timeout, please try again",
      "aborted": "Request was cancelled",
      "parse": "Response parse error",
      "unauthorized": "Please login first",
      "config": "SDK initialization error",
      "unknown": "An unknown error occurred"
    }
  },
  "exchange": {
    "store": {
      "title": "Points Store",
      "myOrders": "My Orders",
      "empty": "No products available",
      "points": "points",
      "stock": "Stock",
      "back": "Back",
      "redeem": "Redeem",
      "soldOut": "Sold Out",
      "noOrders": "No exchange orders yet",
      "redeemSuccess": "Coupon \"{name}\" has been added to your account",
      "couponInfo": "Coupon",
      "status": {
        "pending": "Pending",
        "completed": "Completed",
        "cancelled": "Cancelled"
      }
    }
  },
  "message": {
    "center": {
      "title": "Messages",
      "empty": "No messages yet"
    },
    "type": {
      "system": "System",
      "marketing": "Promotions",
      "transaction": "Transaction",
      "activity": "Activity"
    }
  }
}
